export default __webpack_public_path__ + "dist/olden-era/main.min.css";